import { render, staticRenderFns } from "./DefaultLogin.vue?vue&type=template&id=205e7fda&scoped=true"
import script from "./DefaultLogin.vue?vue&type=script&lang=js"
export * from "./DefaultLogin.vue?vue&type=script&lang=js"
import style0 from "./DefaultLogin.vue?vue&type=style&index=0&id=205e7fda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205e7fda",
  null
  
)

export default component.exports